import styles from "./column.module.css";
import OrderView from "./OrderView";

export default function Column({
  jwt,
  column,
  orders,
  handleDrop,
  handleDragOver,
  onOpenOrder,
}) {
  const totalPrice = orders.reduce((sum, item) => sum + Number(item.price || 0), 0);

  return (
    <section
      className={orders.length > 0 ? styles.column : styles.columnEmpty}
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, column.id)}
    >
      <div className={styles.header}>
        <div className={styles.headerTop}>
          <h3 className={styles.title}>{column?.name}</h3>
          <span className={styles.count}>{orders.length}</span>
        </div>

        <div className={styles.description}>{column?.description}</div>
        <div className={styles.amount}>{totalPrice.toFixed(0)} ₽</div>
      </div>

      <div className={styles.content}>
        {orders.length > 0 ? (
          orders.map((order) => (
            <OrderView
              key={order.id}
              order={order}
              onOpenOrder={() => onOpenOrder(order)}
            />
          ))
        ) : (
          <div className={styles.placeholder}>
            В этой колонке пока нет заказов
          </div>
        )}
      </div>
    </section>
  );
}